import React from 'react'
import _ from 'underscore'
import moment from 'moment'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import Timeago from '../timeago'
import DatetimePicker from '../datetime_picker'

const DEFAULT_DRAFT = () => moment().startOf('hour').format('YYYY-MM-DD HH:mm')

class TaskDue extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false,
      // Buffer the picker's date/time so nothing is committed until "Apply".
      draft: props.due_at || DEFAULT_DRAFT()
    }
  }

  onOpenChange = (open) => {
    // Reset the draft from the current value each time the popover opens;
    // closing (outside click / Escape / Cancel) discards any uncommitted edit.
    if (open) {
      this.setState({ open: true, draft: this.props.due_at || DEFAULT_DRAFT() })
    } else {
      this.setState({ open: false })
    }
  }

  onDraftChange = (value) => {
    this.setState({ draft: value })
  }

  onQuickSelect = (value) => {
    if (value == 'now') {
      value = moment().format('YYYY-MM-DD HH:mm')
    }

    this.setState({ draft: value })
  }

  onApply = () => {
    if (this.state.draft) {
      this.props.onChange(this.state.draft)
    }

    this.setState({ open: false })
  }

  onCancel = () => {
    this.setState({ open: false })
  }

  render() {
    const moments = [
      {value: 'now', name: 'Now'},
      {value: moment().add(1, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(1, 'days').format("dddd")},
      {value: moment().add(2, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(2, 'days').format("dddd")},
      {value: moment().add(3, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(3, 'days').format("dddd")}
    ]

    return (
      <Popover open={this.state.open} onOpenChange={this.onOpenChange}>
        <PopoverTrigger asChild>
          <button type="button" className="text-[#337ab7] hover:underline">
            <Timeago date={this.props.due_at}/>
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-auto px-6 py-4">
          <div className="mb-4">
            When should this task be followed up?
          </div>
          <hr/>
          <div className="flex flex-nowrap gap-4">
            <DatetimePicker
              value={this.state.draft}
              onChange={this.onDraftChange}
            />
            <div className="flex flex-col gap-1 py-4">
              {_.map(moments, (time) => {
                return (
                  <Button key={time.value} variant="outline" size="sm" className="w-full" onClick={() => this.onQuickSelect(time.value)}>{time.name}</Button>
                )
              })}
            </div>
          </div>
          <hr className="my-3"/>
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onCancel}>Cancel</Button>
            <Button size="sm" onClick={this.onApply}>Apply</Button>
          </div>
        </PopoverContent>
      </Popover>
    )
  }
}

export default TaskDue
